import es from 'date-fns/locale/es'

export const redirectPage = (url, time = 3000) => {
  setTimeout(() => {
    window.location.replace(url);
  }, time);
};

export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


export const formatCurrency = (value = 0, brand = 1) => {
  try {
    const currency = parseInt(brand) === 3 ? 'PEN' : 'COP';
    const country = parseInt(brand) === 3 ? 'es-PE' : 'es-CO';

    return new Intl.NumberFormat(country, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
    }).format(value);
  } catch (error) {
    process.error(error);
    return '---';
  }
};

export const formatDate = (date, format = 'yyyy-MMM-dd') => {
  try {
    return format(new Date(date), 'dd LLLL yyyy', { locale: es })
  } catch (err) {
    return undefined
  }
}

export const pagesUrl = {
  '1': 'https://bodytech.com.co/',
  '2': 'https://athleticgym.com.co/',
  '3': 'https://bodytechperu.com/',
}
